import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ChakraProvider, extendTheme, Box } from '@chakra-ui/react';
import Home from './pages/Home';
import Details from './pages/Details';
import EnergyDetails from './pages/EnergyDetails';
import Register from './pages/Register';
import Login from './pages/Login';
import SubscriptionSelect from './pages/SubscriptionSelect';
import Account from './pages/Account';
import Admin from './pages/Admin';
import GoogleLoginCallback from './components/auth/GoogleLoginCallback';
import { AuthProvider, useAuth } from './context/AuthContext';
import Header from './components/Header';
import { Providers } from './providers/Providers';
import Verify from "./pages/Verify";
import { GoogleOAuthProvider } from "@ekaruz/react-social-auth";

const theme = extendTheme({
  colors: {
    brand: {
      primary: '#283278',
      background: '#efe9e1',
      text: '#0057B8',
      red: '#7E1525',
      orange: '#046A38',
      green: '#5B1849', // In App.js or your router configuration
      section: '#FFF',
    },
  },
  fonts: {
    body: "'Arial', 'Helvetica Neue', sans-serif",
    heading: "'Arial', 'Helvetica Neue', sans-serif",
  },
  fontWeights: {
    thin: 100,
    normal: 300,
  },
  styles: {
    global: {
      body: {
        bg: '#d2ccc0',
        color: '#0057B8',
        fontWeight: 'thin',
      },
    },
  },
  components: {
    Card: {
      baseStyle: {
        container: {
          borderRadius: 'lg',
        },
      },
    },
  },
});

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return null; // or a loading spinner
  }

  if (!user) {
    return <Navigate to='/login' />;
  }

  return children;
};

function AppContent() {
  return (
    <>
      <Header />
      <Box pt={4}>
        <Routes>
          <Route path='/verify' element={<Verify />} />
          <Route path='/register' element={<Register />} />
          <Route path='/login' element={<Login />} />
          <Route path='/google-callback' element={<GoogleLoginCallback />} />
          <Route
            path='/subscription'
            element={
              <ProtectedRoute>
                <SubscriptionSelect />
              </ProtectedRoute>
            }
          />
          <Route
            path='/account'
            element={
              <ProtectedRoute>
                <Account />
              </ProtectedRoute>
            }
          />
          <Route path='/' element={<Home />} />
          <Route path='/details' element={<Details />} />
          <Route path='/energy-details' element={<EnergyDetails />} />
          <Route
            path='/admin'
            element={
              <ProtectedRoute>
                <Admin />
              </ProtectedRoute>
            }
          />
        </Routes>
      </Box>
    </>
  );
}

function App() {
  const googleClientId = process.env["REACT_APP_GOOGLE_ID"] || ""

  return (
    <ChakraProvider theme={theme}>
      <BrowserRouter>
        <GoogleOAuthProvider clientId={googleClientId}>
          <Providers>
            <AuthProvider>
              <AppContent />
            </AuthProvider>
          </Providers>
        </GoogleOAuthProvider>
      </BrowserRouter>
    </ChakraProvider>
  );
}

export default App;
